import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from "@fortawesome/free-solid-svg-icons";

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Api
import cnae_api from '../../../api/cnae_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial do CNAE
function initialStateCnae() {
    return {
        codigo: "",
        descricao: "",
        aprovacaoAutomatica: true,
        status: "Ativo"
    }
}
export default function Cnae({ permissao }) {
    //Estado que guarda os dados do CNAE a ser Cadastrado/Editado
    const [cnae, setCnae] = useState(initialStateCnae);

    //Estado que guarda os CNAEs que serão listados
    const [cnaes, setCnaes] = useState([]);

    //Estado de controle do modal de Cadastro/Edição
    const [openModal, setOpenModal] = useState(false);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do Cadastro/Edição
    const campos = [
        objCampo({ name: "codigo", required: true }),
        objCampo({ name: "descricao", required: true }),
    ];

    //Faz a troca do estado do modal
    const toggleModal = () => {
        if (openModal) {
            setCnae(initialStateCnae);
            setErrors({});
        }
        setOpenModal(!openModal);
    };

    //Carrega os CNAEs que serão listados
    const loadCnaes = () => {
        setLoading(true);
        cnae_api.GetList().then(response => {
            setCnaes(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega os CNAEs assim que o componente é iniciado
    useEffect(() => {
        loadCnaes();
    }, []);

    //Change dos campos do CNAE
    const onChangeCnae = (e) => {
        const { name, value } = e.target;
        const _cnae = {
            ...cnae,
            [name]: value
        };
        const campo = campos.filter(c => c.name == name);
        const erros = validarCampos(_cnae, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        setCnae(_cnae);
    }

    //OnChange para o checkbox
    const onChangeCheckbox = (e) => {
        const { name, checked } = e.target;
        setCnae({
            ...cnae,
            [name]: checked
        })
    }

    //Adiciona/Edita um CNAE
    const addNovoCnae = () => {
        const erros = validarCampos(cnae, campos);
        if (erros[1].length > 0) {
            setErrors(erros[0]);
            return;
        }
        setLoading(true);
        if (cnae.id) {
            cnae_api.Put(cnae).then(response => {
                showMessage("Sucesso", "CNAE editado com sucesso", "success");
                loadCnaes();
                toggleModal();
                setCnae(initialStateCnae);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        } else {
            cnae_api.Post(cnae).then(response => {
                showMessage("Sucesso", "CNAE adicionado com sucesso", "success");
                loadCnaes();
                toggleModal();
                setCnae(initialStateCnae);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        }
    }

    //Armazena os dados para que seja feita a edição do CNAE
    const editarCnae = (item) => {
        setCnae(item);
        toggleModal();
    }

    //Variavel que guarda as ações da tabela
    const actions = [];
    if (permissao == "Editar") {
        actions.push(actionsTable.editar(editarCnae));
    }
    //Cabeçalhos da tabela
    const headers = [
        { value: "Código", objectValue: "codigo", align: "left" },
        { value: "Descrição", objectValue: "descricao", align: "left" },
        { value: "Aprovação automática", objectValue: "aprovacaoAutomaticaDescricao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
    ]

    const items = cnaes.map(item => {
        return { ...item, aprovacaoAutomaticaDescricao: item.aprovacaoAutomatica ? "Sim" : "Não" };
    });

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <ModalCustomized title={cnae.id ? <><FontAwesomeIcon icon={faEdit} /> Editar CNAE</> : "Novo CNAE"} isOpen={openModal} toggle={toggleModal} btnAction={cnae.id ? <><FontAwesomeIcon icon={faEdit} className="me-3" /> Editar</> : "+ Adicionar"} btnActionColor={cnae.id ? "warning text-light" : "success"} onClickBtnAction={addNovoCnae} btnClose>
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>
                        <Col md={"12"} lg="4">
                            <TextField mask={mascaras.cnaeMask} invalid={errors.codigo ? true : false} maxLength={"10"} label={"* Código"} name="codigo" value={cnae.codigo} onChange={onChangeCnae} />
                            {errors.codigo && <span className={"form-control-label text-danger"}>{errors.codigo.message}</span>}
                        </Col>
                        <Col md={"12"} lg="8">
                            <TextField invalid={errors.descricao ? true : false} maxLength={"300"} label={"* Descrição"} name="descricao" value={cnae.descricao} onChange={onChangeCnae} />
                            {errors.descricao && <span className={"form-control-label text-danger"}>{errors.descricao.message}</span>}
                        </Col>
                        <Col md={"12"} lg="6">
                            <TextField label={"Status"} name="status" type={"select"} options={[{ text: "Ativo", value: "Ativo" }, { text: "Inativo", value: "Inativo" }]} value={cnae.status} onChange={onChangeCnae} />
                        </Col>
                        <Col md="12" lg="6">
                            <TextField label={"Aprovação automática do cadastro"} type="checkbox" onChange={onChangeCheckbox} value={cnae.aprovacaoAutomatica} name={"aprovacaoAutomatica"} />
                        </Col>
                    </Row>
                </ModalCustomized>
                <div className="mt-4">
                    <TabelaListagem actions={actions} title={"Lista de CNAEs"} options={{ print: false, search: true, pagination: true }} headers={headers} items={items} />
                </div>
            </MainCard>
        </>
    )
}
